import getPrescriberPhone1 from 'utils/print/getPrescriberPhone1';
import getPrescriberPhone2 from 'utils/print/getPrescriberPhone2';
import getPrescriberPhone3 from 'utils/print/getPrescriberPhone3';

const getPrescriberFullPhone = ({ value, ...otherProps }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const phone1 = getPrescriberPhone1(otherProps);
  const phone2 = getPrescriberPhone2(otherProps);
  const phone3 = getPrescriberPhone3(otherProps);
  if (phone1 && phone2 && phone3) {
    return `(${phone1}) ${phone2}-${phone3}`;
  }

  return null;
};

export default getPrescriberFullPhone;



// WEBPACK FOOTER //
// ./src/utils/print/getPrescriberFullPhone.js